export default __webpack_public_path__ + "static/media/img5.e73379ca.png";